import {ValueObject} from '@s-ui/domain'

import {UserTraitTrackingValueObject} from './UserTraitTrackingValueObject.js'

export class UserTraitsTrackingValueObject extends ValueObject {
  #traits

  constructor({traits}) {
    super()
    this.#traits = traits
  }

  static createFromApi({traits}) {
    return new UserTraitsTrackingValueObject({
      traits: Object.entries(traits).map(([traitKey, traitValue]) =>
        UserTraitTrackingValueObject.createFromApi({traitKey, traitValue})
      )
    })
  }

  get traits() {
    return this.#traits.map(trait => trait.value)
  }

  getAttributes() {
    return Object.fromEntries(this.#traits.map(trait => [trait.traitKey, trait.traitValue]))
  }

  getAttributesWithPrefix() {
    return Object.fromEntries(
      this.#traits.filter(trait => trait.hasSegmentPrefix).map(trait => [trait.traitKey, trait.traitValue])
    )
  }

  get value() {
    return {
      traits: this.traits
    }
  }
}
